import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21ad1caa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("mdi-cog")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Nastavení")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("mdi-logout")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Odhlásit se")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" mdi-account-circle-outline ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Přihlásit se ")
const _hoisted_7 = {
  class: "my-4 text-overline",
  app: ""
}
const _hoisted_8 = { class: "text-center text-lg-left mb-0" }
const _hoisted_9 = { class: "footer-links text-center text-lg-right" }
const _hoisted_10 = { class: "footer-links__item" }
const _hoisted_11 = { class: "footer-links__item" }
const _hoisted_12 = { class: "footer-links__item" }
const _hoisted_13 = { class: "footer-links__item" }

import { useUserStore } from '@/stores/UserStore';
import { onMounted } from 'vue';

// STORES

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const userStore = useUserStore();

// HOOKS
onMounted(() => {
  userStore.getUserData();
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_avatar = _resolveComponent("v-list-item-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        flat: "",
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { class: "bg-white rounded-b-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: { name: 'Home' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_img, {
                        src: require('./assets/logo.svg'),
                        width: 87,
                        height: 34
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  (_unref(userStore).isLoggedIn)
                    ? (_openBlock(), _createBlock(_component_v_menu, {
                        key: 0,
                        transition: "slide-y-transition"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(props)), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_avatar, {
                                size: "28",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_img, {
                                    src: _unref(userStore).userData.photo,
                                    "lazy-src": _unref(userStore).userData.photoLazy,
                                    alt: _unref(userStore).userData.name
                                  }, null, 8, ["src", "lazy-src", "alt"])
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_unref(userStore).userData.name), 1)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, { to: { name: 'GeneralSettings' } }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_avatar, { start: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _hoisted_1
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _hoisted_2
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                onClick: _unref(userStore).logout
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_avatar, { start: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _hoisted_3
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        to: { name: 'AuthLogin' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "primary",
                            start: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }),
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createElementVNode("footer", _hoisted_7, [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              justify: "center",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  lg: "6"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_8, " © " + _toDisplayString(new Date().getFullYear()) + " Intee ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  lg: "6"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_9, [
                      _createElementVNode("li", _hoisted_10, [
                        _createVNode(_component_router_link, { to: { name: 'Terms' } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('footer.links.terms')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_11, [
                        _createVNode(_component_router_link, { to: { name: 'Privacy' } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('footer.links.privacy')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_12, [
                        _createVNode(_component_router_link, { to: { name: 'About' } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('footer.links.about')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_13, [
                        _createVNode(_component_router_link, { to: { name: 'Contacts' } }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('footer.links.contacts')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})